module.exports = __webpack_public_path__ + "static/media/calvin-klein.50086d41.svg";